import React from 'react';
import Select from '../UI/Select';

const USER_ROLES_LIST = [
  {
    value: "business", 
    label: "Business", 
    type: "role"
  },
  {
    value: "officer", 
    label: "Officer", 
    type: "role"
  },
  {
    value: "admin", 
    label: "Admin", 
    type: "role"
  }
]

const USER_ROLES_VALIDATOR = {
  business: "Business",
  admin: "Admin",
  officer: "Officer"
};

const ChangeAccountTypeModalContent = ({ role, onChangeHandler }) => {
  return (
    <>
      <h5 className="mb-4">Choose Account Type</h5>
      <Select 
        handleMultiChange={onChangeHandler}
        name="role"
        list={USER_ROLES_LIST}
        styles="react-select-input-container"
        prefixStyles="react-select-input"
        indicator={false}
        isSearchable={false}
        isClear={false}
        defaultValue={{value: role, label: USER_ROLES_VALIDATOR[role], type: "role"}}
      />
    </>
  )
}

export default ChangeAccountTypeModalContent;